import { Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
// import { GameConfigs } from "../lib/globals/GameConfigs";

class PaginationController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		const { slides } = this.config;
		this.currentIndex = Math.min(
			Math.max(0, conf.currentIndex || 0),
			slides.length - 1
		);
		this.process = this.process.bind(this);
		this.container = this.vc.slider_bg.pagination.pagination_holder;
		if (this.vc.slider_bg.getChildByName(this.config.item)) {
			for (const arrow of [
				this.vc.slider_bg.pagination.arrow_left,
				this.vc.slider_bg.pagination.arrow_right
			]) {
				arrow.handler = this.process.bind(this);
			}
		} else {
			throw new Error(
				'CloseController failed init ' + JSON.stringify(this.config)
			);
		}
		this.buttonCooldown = false;
		// attach click event listeners to arrow buttons

		///TODO! REFACTOR THIS
		for (const arrow of [
			this.vc.slider_bg.pagination.arrow_left,
			this.vc.slider_bg.pagination.arrow_right
		]) {
			arrow.interactive = true;
			arrow.on('pointerdown', () => {
				arrow.scale.set(0.9);
				setTimeout(() => {
					arrow.scale.set(1);
				}, 200);
			});
			arrow.on('pointerover', () => {
				arrow.alpha = 0.8;
			});
			arrow.on('pointerout', () => {
				arrow.alpha = 1;
			});
			arrow.on(window.isMobile || window.isTablet ? 'tap' : 'click', () => {
				if (!this.buttonCooldown) {
					this.buttonCooldown = true;
					this.handleLoop();
					setTimeout(() => {
						this.buttonCooldown = false;
						this.handleLoop();
					}, 50);
				}
			});
		}
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		this.length = this.config.slides.length;
		// GameConfigs.config.hasquest
		//   : this.config.slides.length - 1;
		this.hideAll(this.config.slides.length);
		this.initActiveSlide(this.length);
		this.addPaginations(this.length);
		this.handleLoop(this.length);
		this.hideSlides(0, this.length);
	}

	hideAll(slice) {
		for (var i = 0; i < slice; i++) {
			this.vc.slider_bg[this.config.slides[i].slide].alpha = 0;
		}
	}
	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.vc.slider_bg.pagination.arrow_left.interactive = false;
					this.vc.slider_bg.pagination.arrow_right.interactive = false;
					window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
				}
				break;
			default:
				break;
		}
	}
	initActiveSlide(length) {
		for (var i = 0; i < length; i++) {
			if (this.currentIndex !== i) {
				this.vc.slider_bg[this.config.slides[i].slide].alpha = 0;
			}
		}
	}

	process(str) {
		// ignore button clicks while the cooldown is active
		if (this.buttonCooldown) {
			return;
		}
		switch (str) {
			case 'arrow_right':
				this.currentIndex++;
				break;
			case 'arrow_left':
				this.currentIndex--;
				break;
			default:
				break;
		}
		this.handleLoop(this.length);
		this.hideSlides(700, this.length);
		// set the buttonClooldown true to prevent futher clicks
		this.buttonCooldown = true;
	}

	handleLoop(length) {
		if (this.currentIndex === -1) {
			this.currentIndex = length - 1;
		}
		if (this.currentIndex === length) {
			this.currentIndex = 0;
		}
	}

	hideSlides(time, length) {
		// hide all slides except the current one
		for (let i = 0; i < length; i++) {
			if (i !== this.currentIndex) {
				new Tween(this.vc.slider_bg[this.config.slides[i].slide])
					.to({ alpha: 0 }, time)
					.easing(Easing.Linear.None)
					.start();
				new Tween(this.container[this.config.pagination[i].active])
					.to({ alpha: 0 }, time)
					.easing(Easing.Linear.None)
					.start();
				new Tween(this.container[this.config.pagination[i].inactive])
					.to({ alpha: 1 }, time)
					.easing(Easing.Linear.None)
					.start();
			}
		}
		// show the current slide
		new Tween(this.vc.slider_bg[this.config.slides[this.currentIndex].slide])
			.to({ alpha: 1 }, time)
			.easing(Easing.Linear.None)
			.start();
		new Tween(this.container[this.config.pagination[this.currentIndex].active])
			.to({ alpha: 1 }, time)
			.easing(Easing.Linear.None)
			.start();
		new Tween(
			this.container[this.config.pagination[this.currentIndex].inactive]
		)
			.to({ alpha: 0 }, time)
			.easing(Easing.Linear.None)
			.start();
		// add delay to re-enable the buttons after the slider animation is complete
		setTimeout(() => {
			this.buttonCooldown = false;
			this.handleLoop();
		}, time + 50);
	}
	addPaginations(length) {
		const dist = 40;
		const paginationButtons = [];
		const x = this.vc.slider_bg.settings_page_main_bg.getBounds().width / 2;
		const y = 670;
		// const y = this.vc.slider_bg.getBounds().height;

		// console.log(this.vc.slider_bg.getBounds().width, 'this.vc.slider_bg.getBounds().width')
		for (const [i, { active, inactive }] of Object.entries(
			this.config.pagination.slice(0, length)
		)) {
			const activeButton = new Sprite(
				Texture.from(this.config.pagination_bullet_active)
			);
			const inactiveButton = new Sprite(
				Texture.from(this.config.pagination_bullet_inactive)
			);
			this.container.addChild(activeButton, activeButton);
			this.container.addChild(inactiveButton, inactiveButton);
			const posX = x - (length - i) * dist + (length * dist) / 2 + 10;
			activeButton.position.set(posX, y - dist * 1.5);
			inactiveButton.position.set(posX, y - dist * 1.5);
			this.container[active] = activeButton;
			this.container[inactive] = inactiveButton;
			paginationButtons.push(activeButton);
			activeButton.interactive = true;
			activeButton.buttonMode = true;
			activeButton.cursor = 'pointer';
			activeButton.alpha = 1;
			activeButton.on('pointerover', () => {
				activeButton.alpha = 0.9;
			});
			activeButton.on('pointerout', () => {
				activeButton.alpha = 1;
			});
		}
		for (const [index, button] of paginationButtons.entries()) {
			if (button) {
				button.interactive = true;
				button.buttonMode = true;
				button.cursor = 'pointer';
				button.on(window.isMobile || window.isTablet ? 'tap' : 'click', () => {
					if (!this.buttonCooldown) {
						this.currentIndex = index;
						this.buttonCooldown = true;
						this.handleLoop(this.length);
						this.hideSlides(700, this.length);
						setTimeout(() => {
							this.buttonCooldown = false;
							this.handleLoop(this.length);
						}, 50);
					}
				});
			}
		}
	}
}

export default PaginationController;
